import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { getAuth, getAuthStatus } from "./getters";
import { authStore } from "./store";
import type { AuthState, AuthStore } from "./store.types";

export function useAuth(): AuthState {
  return useAuthStore(getAuth);
}

export function useAuthStatus(): AuthState["status"] {
  return useStore(authStore, getAuthStatus);
}

export function useIsOnline(): AuthState["isOnline"] {
  return useStore(authStore, (state) => state.isOnline);
}

export function useAuthStore<T = AuthStore>(
  selector: (state: AuthStore) => T = (state) => state as T
): T {
  return useStore(authStore, useShallow(selector));
}
